import { useContext, useEffect, useState } from 'react';
import PodriaInteresarte from '../home/PodriaInteresarte';
import axios from "@fetch/axios";
import ProductoResultado from '../home/ProductoResultado';
import { TokenContext } from '@context/TokenContext';
import { LanguageCurrencyContext } from '@context/LanguageCurrencyContext';
import { useTranslation } from '@hooks/useTranslation';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

const WishList = () => {

	const [productos, setProductos] = useState([]);
	const { getToken } = useContext(TokenContext);
	const { lang, currency } = useContext(LanguageCurrencyContext);
	const { translate } = useTranslation();
	const MySwal = withReactContent(Swal)

	const fetchWish = async () => {

		try {
			const res = await axios.get('/products/wishlist' + `?lang=` + lang + `&currency=` + currency, {
				headers: { 'Authorization': 'Bearer ' + getToken() }
			});
			const pd = res.data;
			setProductos(pd);

		} catch (error) {

			MySwal.fire({
				text: translate('wishlist.noavailable'),
				icon: 'error',
				title: 'Oops...'
			})

		}
	};

	useEffect(() => {

		fetchWish();

	}, [lang, currency])

	return (
		<>
			<div className='WishList pt-tophead'>
				<h3>{translate('wishlist.list')}</h3>
				<p>{productos.length} {translate('wishlist.articles')}</p>
			</div>
			<section className='ColeccionItems ColeccionVertical WishList'>
				{productos.map((producto, index) => (

					<ProductoResultado
						key={index}
						producto={producto}
						ejecutar={fetchWish}
					/>

				))}
			</section>
			<PodriaInteresarte />
		</>
	);
};

export default WishList;